export const STAFF_ADD_SUCCESS = 'STAFF_ADD_SUCCESS';
export const STAFF_ADD_FAILURE = 'STAFF_ADD_FAILURE';
export const STAFF_ADD_REQUEST = 'STAFF_ADD_REQUEST';

export const STAFF_UPDATE_SUCCESS = 'STAFF_UPDATE_SUCCESS';
export const STAFF_UPDATE_FAILURE = 'STAFF_UPDATE_FAILURE';
export const STAFF_UPDATE_REQUEST = 'STAFF_UPDATE_REQUEST';

export const STAFF_VIEW_ALL_SUCCESS = 'STAFF_VIEW_ALL_SUCCESS';
export const STAFF_VIEW_ALL_FAILURE = 'STAFF_VIEW_ALL_FAILURE';
export const STAFF_VIEW_ALL_REQUEST = 'STAFF_VIEW_ALL_REQUEST';

export const STAFF_FETCH_ALL_SUCCESS = 'STAFF_FETCH_ALL_SUCCESS';
export const STAFF_FETCH_ALL_FAILURE = 'STAFF_FETCH_ALL_FAILURE';
export const STAFF_FETCH_ALL_REQUEST = 'STAFF_FETCH_ALL_REQUEST';

export const STAFF_DELETE_SUCCESS = 'STAFF_DELETE_SUCCESS';
export const STAFF_DELETE_FAILURE = 'STAFF_DELETE_FAILURE';
export const STAFF_DELETE_REQUEST = 'STAFF_DELETE_REQUEST';

export const STAFF_VIEW_SUCCESS = 'STAFF_PARTICULAR_VIEW_SUCCESS';
export const STAFF_VIEW_FAILURE = 'STAFF_PARTICULAR_VIEW_FAILURE';
export const STAFF_VIEW_REQUEST = 'STAFF_PARTICULAR_VIEW_REQUEST';
export const RESET_STAFF_DETAIL = 'RESET_STAFF_DETAIL';
